module.exports = __webpack_public_path__ + "static/media/pistons.a0f4d2f3.jpg";